import React from 'react';
import ConfirmationDialog from '../../ConfirmationDialog';

const SignDialogBody = ({ selectedTasks }) => {
    return(
        <div className="sign-dialog">
            {selectedTasks.map(task =>
                <div key={task.taskId} className="sign-dialog--task">
                    <div>TASK:</div>
                    <div>{task.description}</div>
                </div>
            )}
        </div>
    );
}

const TaskSignDialog = ({ tasks, onClose, onAccept, ...props }) =>
    <ConfirmationDialog
        {...props}
        onClose = { onClose }
        cancelButton={{
            action: onClose,
            label: 'NO, CANCEL'
        }}
        acceptButton={{
            action: onAccept,
            label: 'YES, SIGN'
        }}
        header="Do you confirm that  you completed this task?"
        body={<SignDialogBody selectedTasks={tasks} />}
    />;

export default TaskSignDialog;